import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FaServer, FaTablet, FaUserCog } from "react-icons/fa";
import "./Hardware.css";

const Hardware = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section className="hardware" ref={ref}>
      <motion.div
        className="hardware-content"
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 1 }}
      >
        <h2>Enterprise-Grade Hardware Solution</h2>

        <div className="hardware-grid">
          <motion.div
            className="hardware-item"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="icon-container">
              <FaTablet className="hardware-icon" />
            </div>
            <h3>iPad Pro Deployment</h3>
            <p>Strategic placement of iPad Pro devices across your vessel:</p>
            <ul>
              <li>Every lifeboat station</li>
              <li>Dual units on the Bridge</li>
              <li>Engine Control Room (ECR)</li>
            </ul>
          </motion.div>

          <motion.div
            className="hardware-item"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <div className="icon-container">
              <FaServer className="hardware-icon" />
            </div>
            <h3>Redundant Dual Server Architecture</h3>
            <p>
              Enhanced reliability through <span>redundancy</span>:
            </p>
            <ul>
              <li>Primary and backup servers</li>
              <li>Automatic failover capability</li>
              <li>Continuous data synchronization</li>
            </ul>
          </motion.div>

          <motion.div
            className="hardware-item"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            <div className="icon-container">
              <FaUserCog className="hardware-icon" />
            </div>
            <h3>Customization & Support</h3>
            <p>Tailored to your vessel's requirements:</p>
            <ul>
              <li>Flexible hardware configurations</li>
              <li>On-board technical support</li>
              <li>Custom installation options</li>
            </ul>
          </motion.div>
        </div>

        <motion.div
          className="hardware-note"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 1, delay: 1 }}
        >
          <p>
            All hardware specifications can be customized to meet your ship's
            specific requirements and safety regulations.
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hardware;
